import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../api/apiHelper'; // Twój helper
import { invalidateApiCache } from '../../utils/apiCache';
import GlobalSpinner from '../common/GlobalSpinner';

// Dokad link z maila moze przekierowac po zalogowaniu (bez next = /upgrade, jak dotad).
const ALLOWED_NEXT = ['/app', '/upgrade'];

const MagicLogin = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const tokenFromLink = searchParams.get('token');
    const [error, setError] = useState(null);

    useEffect(() => {
        // Jeśli brak tokena, goń do logowania
        if (!tokenFromLink) {
            navigate('/login');
            return;
        }

        const performMagicLogin = async () => {
            try {
                // 1. HIGIENA: Czyścimy stare dane, żeby wejść na czysto
                localStorage.removeItem('token'); 
                localStorage.removeItem('user_preferences');
                localStorage.removeItem('userStatus'); // Opcjonalnie, jeśli też trzymasz
                
                // 2. STRZAŁ DO API (do nowego widoku)
                const response = await api.post('/magic-login/', { 
                    token: tokenFromLink 
                });

                // Odbieramy dane z odpowiedzi
                const { token, refresh, preferences } = response.data;

                // 3. ZAPISUJEMY DANE (Kluczowy moment)
                // Najpierw tokeny
                localStorage.setItem('token', token);
                if (refresh) localStorage.setItem('refresh_token', refresh);
                invalidateApiCache('user_dashboard_data', true);
                
                // TERAZ NAJWAŻNIEJSZE: Zapisujemy preferencje (w tym is_profile_complete)
                if (preferences) {
                    localStorage.setItem('user_preferences', JSON.stringify(preferences));
                }

                console.log("Magic Login Sukces! Profil kompletny?", preferences?.is_profile_complete);

                // 4. PRZEKIEROWANIE
                // Ponieważ user_preferences są już w localStorage, 
                // App.js/ProtectedRoute zobaczy, że user jest kompletny i wpuści go do płatności.
                const next = searchParams.get('next');
                navigate(ALLOWED_NEXT.includes(next) ? next : '/upgrade');

            } catch (err) {
                console.error("Magic Login Error:", err);
                setError("Link jest nieprawidłowy lub wygasł.");
                // Po 3 sekundach przekieruj do zwykłego logowania
                setTimeout(() => navigate('/login'), 3000);
            }
        };

        performMagicLogin();

    }, [tokenFromLink, navigate]);

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-red-600 p-4 text-center">
                <h2 className="text-xl font-bold mb-2">Ups! 😕</h2>
                <p>{error}</p>
                <p className="text-sm text-gray-500 mt-4">Przenoszę do logowania...</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-white">
            <GlobalSpinner />
            <p className="mt-6 text-gray-600 font-medium animate-pulse">
                Logowanie magiczne... ✨
            </p>
        </div>
    );
};

export default MagicLogin;